<template>
  <div class="page news-list">
    <div class="container">
      <!-- <div class="category-filter">
        <div class="filter-category">
          <div class="filter-title">资讯类型：</div>
          <div class="filter-content">
            <div
              class="item"
              :class="{ 'item item-active': queryParams.category_id === '' }"
              @click.stop="changeSort('')"
            >全部</div>
            <div
              class="item"
              v-for="(item, index) in sortList"
              :key="index"
              :class="{
                'item-active': queryParams.category_id === item.id,
              }"
              @click.stop="changeSort(item.id)"
            >{{ item.name }}</div>
          </div>
        </div>
      </div>-->
      <el-breadcrumb separator-class="el-icon-arrow-right" class="news-breadcrumb">
        <el-breadcrumb-item :to="{ path: '/home' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>新闻列表</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="showcase" :class="!listData.length ? 'showcase-empty' : ''">
        <template v-if="listData.length">
          <div class="goods-list">
            <div class="goods-item" v-for="(item, index) in listData" :key="index" @click="todetail(item)">
              <div class="goods-item--img" v-if="item.cover">
                <el-image class="image" :src="item.cover" @error="handleError" />
              </div>
              <div class="goods-item--text">
                <div class="goods-item-date">
                  <div class="date">{{ item.month }}-{{ item.day }}</div>
                  <div class="year">{{ item.year }}</div>
                  <div class="icon"></div>
                </div>
                <div class="goods-item-info">
                  <div class="title multiple-ellipsis">{{ item.title }}</div>
                  <div class="content multiple-ellipsis">
                    <span class="txt" v-html="item.content"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="elpagination">
            <div class="elpagination-title">共{{ total }}条</div>
            <el-pagination background layout="prev, pager, next, jumper" prev-text="上一页" next-text="下一页" :total="total"
              :current-page="queryParams.page" :page-size="queryParams.per_page"
              @current-change="pageChange"></el-pagination>
          </div>
        </template>
        <template v-else>
          <el-empty :image-size="110" class="el-empty--cont"></el-empty>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsList } from "@/api/activity"
import dayjs from "dayjs"
export default {
  name: "NewsList",
  components: {},
  data() {
    return {
      goodsimage: require("@/assets/default/image02.jpg"),
      listData: [],
      queryParams: {
        // category_id: "",
        per_page: 10,
        page: 1,
      },
      total: 0,
      sortList: [],
    }
  },
  computed: {},
  created() { },
  mounted() {
    this.getList()
  },
  methods: {
    // 获取列表数据
    getList() {
      getNewsList(this.queryParams).then((res) => {
        if (res.code === 0) {
          let resData = res.data?.data?.map(item => {
            let dateStr = dayjs.unix(item.updated_at).format("YYYY-MM-DD").split('-')
            item.year = dateStr[0]
            item.month = dateStr[1]
            item.day = dateStr[2]
            return item
          })
          this.listData = resData
          this.total = res.data?.total ?? 0
        }
      }).catch(() => { })
    },
    //页码发生改变时
    pageChange(val) {
      this.queryParams.page = val
      this.getList()
    },
    handleError(e) {
      e.target.src = this.goodsimage
    },
    // changeSort (id) {
    //   this.queryParams.category_id = id || ""
    //   this.queryParams.page = 1
    //   this.getList()
    // },
    todetail(item) {
      window.localStorage.setItem("menuId", 2)
      this.$store.dispatch("setmenuid", 2)
      this.$router.push({
        path: "/home/news/detail",
        query: {
          id: item.id,
        },
      })
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  margin: 0 auto 30px;
  overflow: hidden;

  .container {
    margin-top: 30px;
    // .category-filter {
    //   min-height: 60px;
    //   padding: 20px 30px;
    //   background: #fff;
    //   border-radius: 5px;
    //   .filter-category {
    //     display: flex;
    //     justify-content: flex-start;
    //     align-items: flex-start;
    //     margin-bottom: 20px;
    //     &:last-child {
    //       margin-bottom: 0;
    //     }
    //     .filter-title {
    //       flex-basis: 80px;
    //       color: #333;
    //       font-size: 16px;
    //       line-height: 30px;
    //       font-weight: 400;
    //       user-select: none;
    //       white-space: nowrap;
    //     }
    //     .filter-content {
    //       flex-grow: 1;
    //       flex-shrink: 1;
    //       margin-left: 20px;
    //       .item {
    //         display: inline-block;
    //         color: #333;
    //         font-size: 16px;
    //         font-weight: 400;
    //         margin-bottom: 10px;
    //         margin-right: 25px;
    //         user-select: none;
    //         white-space: nowrap;
    //         cursor: pointer;
    //         padding: 0 15px;
    //       }

    //       .item-active {
    //         color: #005cbb;
    //         height: 30px;
    //         line-height: 30px;
    //         background: #e5eef8;
    //         border-radius: 15px;
    //         text-align: center;
    //       }
    //     }
    //   }
    // }
    .news-breadcrumb {
      ::v-deep {
        .el-breadcrumb__item {
          display: flex;
          align-items: center;
          height: 24px;
          font-size: 16px;

          .el-breadcrumb__inner {
            height: 100%;
            line-height: 24px;
          }

          .el-icon-s-home {
            font-size: 24px;
          }

          .el-icon-arrow-right {
            height: 100%;
            line-height: 26px;
          }
        }
      }
    }

    .showcase {
      .goods-list {

        // display: flex;
        // justify-content: flex-start;
        // align-items: center;
        // flex-wrap: wrap;
        .goods-item {
          display: flex;
          height: 190px;
          background-color: #fff;
          border-radius: 5px;
          overflow: hidden;
          margin-top: 20px;
          cursor: pointer;

          // &:hover {
          //   border: 1px solid rgb(9, 235, 178);
          // }
          .goods-item--img {
            width: 285px;
            min-width: 285px;
            height: 100%;
            background: aliceblue;
            overflow: hidden;

            .image {
              -webkit-transition-duration: 0.3s;
              transition-duration: 0.3s;
              -webkit-transition-property: transform;
              transition-property: transform;
              -webkit-transform: translateZ(0);
              transform: translateZ(0);
              box-shadow: 0 0 1px rgba(0, 0, 0, 0);
            }

            .image:hover,
            .image:focus,
            .image:active {
              -webkit-transform: scale(1.1);
              transform: scale(1.1);
            }

            .image {
              width: 100%;
              height: 100%;
            }
          }

          .goods-item--text {
            width: calc(100% - 285px);
            background-color: #fff;
            padding: 30px;
            display: flex;

            .goods-item-date {
              width: 130px;
              min-width: 70px;
              padding: 0px 30px;
              box-sizing: border-box;

              .date {
                color: #000000;
                font-size: 24px;
                font-weight: 500;
                line-height: 40px;
              }

              .year {
                color: #999999;
                font-size: 12px;
                font-weight: 400;
                line-height: 30px;
              }

              .icon {
                width: 30px;
                height: 30px;
                background: url('~@/assets/home/details_gray.png') no-repeat;
                background-position: center;
                background-size: cover;
                margin-top: 20px;
              }

              &:hover .icon {
                transform: translateX(50%);
                transition: 0.4s all;
              }
            }

            .goods-item-info {
              flex: 1;

              .title {
                color: #000000;
                font-size: 18px;
                font-weight: 500;
                margin-bottom: 10px;
                -webkit-line-clamp: 2 !important;
              }

              .content {
                word-break: break-all;
                white-space: pre-wrap;
                overflow-wrap: break-word;

                .txt {
                  color: #333;
                  font-size: 12px;
                  font-weight: 400;
                  text-align: justify;
                  line-height: 20px;
                  border-radius: 12px;
                  margin-bottom: 10px;
                }
              }
            }
          }
        }
      }

      .elpagination {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 30px 5px 30px 0px;

        .elpagination-title {
          margin-right: 10px;
        }
      }

      .el-empty--cont {
        padding: 0px;
        min-height: 400px;
      }
    }

    .showcase-empty {
      background-color: #fff;
      border-radius: 5px;
      margin-top: 30px;
      overflow: hidden;
    }
  }
}

@media screen and (max-width: 640px) {
  .page {
    // padding: 0 10px;
    box-sizing: border-box;

    .container {
      margin-top: 15px;

      .news-breadcrumb {
        ::v-deep .el-breadcrumb__item {
          font-size: 13px;

          .el-icon-s-home {
            font-size: 18px;
          }
        }
      }

      .showcase {
        .goods-list {
          .goods-item {
            flex-direction: column;
            height: auto;

            .goods-item--img {
              width: 100%;
              min-width: 100%;
              height: 180px;

              .image {
                display: block;
                object-fit: cover;
              }
            }

            .goods-item--text {
              width: calc(100% - 30px);
              padding: 12px 15px;
              flex-direction: column;

              .goods-item-date {
                width: 100%;
                padding: 0;
                display: flex;
                align-items: baseline;
                margin-bottom: 8px;

                .date {
                  font-size: 18px;
                  line-height: 1.5;
                  margin-right: 8px;
                }

                .year {
                  font-size: 12px;
                  line-height: 1.5;
                  color: #999;
                }

                .icon {
                  display: none;
                }
              }

              .goods-item-info {
                .title {
                  font-size: 15px;
                }

                .content {
                  .txt {
                    font-size: 14px;
                    line-height: 18px;
                  }
                }
              }
            }
          }

          .goods-item:first-child {
            margin-top: 10px;
          }
        }

        .elpagination {
          // flex-direction: column;
          align-items: flex-start;
          justify-content: center;

          .elpagination-title {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .page {
    .container {
      .showcase {
        .goods-list {
          .goods-item {
            height: 160px;

            .goods-item--img {
              width: 200px;
              min-width: 200px;

              .image {
                display: block;
                object-fit: cover;
              }
            }

            .goods-item--text {
              width: calc(100% - 200px);
              padding: 20px;

              .goods-item-date {
                width: 90px;
                min-width: 60px;
                padding: 0 20px;

                .date {
                  font-size: 20px;
                  line-height: 32px;
                }

                .icon {
                  margin-top: 10px;
                }
              }

              .goods-item-info {
                .title {
                  font-size: 16px;
                }

                .content {
                  .txt {
                    font-size: 11px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>